<template>
  <v-dialog :value="value" @input="toggleModal" max-width="700px" persistent>
    <MessageDialog
      :show.sync="dialogMessage.show"
      :message="dialogMessage.message"
      :error="dialogMessage.isError"
    />
    <v-card>
      <v-toolbar class="header" flat>
        <v-toolbar-title>
          Ingresa un Email válido
        </v-toolbar-title>
        <v-spacer />
        <v-icon class="mr-2" @click="toggleModal">
          mdi-close
        </v-icon>
      </v-toolbar>

      <v-card-text>
        <v-form v-model="valid" lazy-validation ref="form">
          <v-row justify="center" class="mt-3">
            <v-col cols="12" sm="10">
              <v-text-field placeholder="Email"
                            solo
                            v-model="email"
                            :rules="[rules.required, rules.email]"
                            prepend-inner-icon="mdi-email"
                            class="rounded-input"
              />
            </v-col>
          </v-row>
          <v-row justify="center" class="mb-4 px-2">
            <v-col cols="12" sm="6">
              <v-layout justify-center>
                <VueRecaptcha @render="onRender" @verify="onVerify" @expired="onExpired" ref="recaptcha"
                  sitekey="6LdRjfIhAAAAABpxtpdkBk6iEUUrN9SF0PZf2MTq" />
              </v-layout>
            </v-col>
          </v-row>

          <v-row justify="center" class="mb-1">
            <v-col cols="12" sm="6">
              <v-btn class="falkon-btn"
                     @click="submit"
                     :loading="loading"
                     :disabled="loading || !valid"
                     block>
                Continuar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { post } from "@/services/apiService";
import MessageDialog from "@/components/Messages/Dialog.vue";
import VueRecaptcha from "vue-recaptcha";
import rules from "@/components/Validations.js";
import recaptchaLoader from "@/services/recaptchaLoader";

export default {
  props: ['value'],
  components: { MessageDialog, VueRecaptcha },
  watch: {
    // El captcha de Login.vue se carga diferido (6s); si el usuario abre "olvidé mi
    // contraseña" antes de eso, se necesita ya. inject() es idempotente.
    value(isOpen) {
      if (isOpen) recaptchaLoader.inject();
    }
  },
  data: () => ({
    rules,
    valid: true,
    loading: false,
    email: '',
    dialogMessage: {
      show: false,
      message: "",
      isError: true
    },
    captcha: {
      id: null,
      value: null,
      error: false,
    },
  }),
  methods: {
    toggleModal(){
      this.$emit('input', false)
    },
    async submit () {
      if (!this.captcha.value || this.captcha.error == true ) {
        this.captcha.error = true;
        return;
      }
      if (this.$refs.form.validate()) {       
        const dataSend = { 
          email: this.email ,
          recaptcha: this.captcha.value 
        };
        this.loading = true;
        const isEmailSend = await post('channel/api/auth/verify-email', dataSend);       
        this.resetCaptcha();
        this.captcha.value = null;
        this.$refs.form.reset();
        if (!isEmailSend.success) {                
          this.dialogMessage.message = 'El correo no se encuentra registrado o se registró por redes sociales';
          this.dialogMessage.show = true;
          this.dialogMessage.isError = true;
          this.loading = false;
        }
        this.toggleModal();
        this.dialogMessage.message = isEmailSend.data.message;
        this.dialogMessage.show = true;
        this.dialogMessage.isError = false;
        this.loading = false;
      }
    },
    resetCaptcha() {
      this.captcha.value = null;
      this.captcha.error = false;
      if (window.grecaptcha) window.grecaptcha.reset(this.captcha.id);
    },
    onVerify(value) {
      this.captcha.value = value;
      this.captcha.error = false;
    },
    onRender(id) {
      this.captcha.id = id;
    },
    onExpired() {
      this.captcha.value = null;
      this.captcha.error = true;
      if (window.grecaptcha) window.grecaptcha.reset(this.captcha.id);
    },
  }
}
</script>
<style lang="scss">
  iframe[title="reCAPTCHA"]{
    max-width: 100% !important;
  }
</style>

<style lang="scss" scoped>
.header {
  background-color: #5ddead !important;
  color: #fff;
  font-weight: bold;
  text-transform: uppercase;
}

.falkon-btn {
  border-radius: 35px;
  display: inline-flex;
  height: scaleVW(51, 1920);
  padding: 0 scaleVW(30, 1920);
  font-size: scaleVW(16, 1920);
  line-height: 1;
  color: #fff;
  background-color: #ffa141 !important;
  font-weight: 700;
  text-decoration: none;
  align-items: center;
  border: 1px solid #ffa141;
}

</style>
